export const WHATSAPP_NUMBER = '5511936184397'

export const WHATSAPP_MESSAGE =
  'Olá! Gostaria de saber mais sobre holdings patrimoniais.'

export const CONTACT_EMAIL = 'contato@patriar.com.br'

export function getWhatsAppUrl(
  message: string = WHATSAPP_MESSAGE,
  phoneNumber: string = WHATSAPP_NUMBER,
): string {
  return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
}
